<template>
  <div :class="classes">
   <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table" isAddPageToRouter :isOutside="isOutside">
        <wt-table :list="tableData" :labels="tableLabels" v-loading="loading" >
            <slot/>
        </wt-table>
    </wt-paged-table>
    </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-qr-code-table'

export default {
  name: 'pt-qr-code-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
